import { CustomerDTO } from "../DTO/customerDTO";
import { UserDTO } from "../DTO/userDTO";
import { BasicRequest } from "./basicRequest";

export class CreateCustomerRequest extends BasicRequest{
   
    public customer! : CustomerDTO;
    public user! : UserDTO;
    
    constructor(){
        super();
    }
}